const LocalStore = require('./local-store').default;
const BulkCollection = require('./bulk-collection');

module.exports = function(name) {
	return new BulkCollection(new LocalStore(name));
};
